import styled from 'styled-components'
import { Media, mbSize } from '../../theme'

export const Swiper = styled.div<{
  $width: string
  $height: string
  $mbWidth: number
  $mbHeight: string
}>`
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};
  overflow: hidden;
  position: relative;
  ${Media.lessThan(Media.small)} {
    width: ${({ $mbWidth }) => mbSize($mbWidth)};
    height: ${({ $mbHeight }) => $mbHeight};
  }
`

export const SwiperWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  transition: 0.3s transform ease-in-out;
  transition-delay: 0ms;
  > * {
    flex-shrink: 0;
  }
`
